import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import { useParams, withRouter } from 'react-router';
import PiConnectionEditService from '../service/PiConnectionEditService';

const config = () => ({
	key: 'piConnectionEditForm',
	text: 'PI Connection',
	topic: 'piConnection',
	service: PiConnectionEditService,
	fields: () => [
		{
			key: 'name',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'apiUrl',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'username',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'password',
			component: EditFormTextField,
			required: true,
			autoComplete: 'new-password',
			type: 'password'
		},
		{
			key: 'serverId',
			component: EditFormTextField,
			required: true
		}
	]
});

function PiConnectionEditForm() {
	const { id } = useParams();
	return <EditFormPage config={config({ id })} />;
}

export default withRouter(PiConnectionEditForm);
